import * as React from 'react';
import { st, classes } from './Divider.st.css';
export const Divider = (props) => {
    const { className, direction = 'horizontal' } = props;
    return (React.createElement("hr", { "data-hook": props['data-hook'], className: st(classes.root, { direction }, className) }));
};
//# sourceMappingURL=Divider.js.map